import axios from '@/utils/api'

const state = {}

const getters = {}

const actions = {
  async criarMensagem ({ commit }, dados) {
    await axios({
      method: 'post',
      data: dados,
      url: dados.idProcesso ? `conversa?idProcesso=${dados.idProcesso}` : 'conversa'
    })
  },
  async addMensagem ({ commit }, dados) {
    await axios({
      method: 'post',
      data: dados,
      url: `conversa/mensagem`
    })
  },
  async conversaByProcessoId ({ commit }, idProcesso) {
    const dados = await axios({
      method: 'post',
      data: idProcesso,
      url: `conversa/v2/findByProcesso`
    })
    return dados
  },
  async hasConversaByProcesso ({ commit }, data) {
    const dados = await axios({
      method: 'post',
      data,
      url: `conversa/hasConversaByProcesso`
    })
    return dados
  },
  async prolongarConversa ({ commit }, idConversa) {
    const dados = await axios({
      method: 'post',
      url: `conversa/prolongarConversa/${idConversa}`
    })
    return dados
  },
  async encerrarConversa ({ commit }, dados) {
    await axios({
      method: 'post',
      data: dados,
      url: `conversa/encerra`
    })
  },
  async encerrarConversaManutencao ({ commit }, idConversa) {
    await axios({
      method: 'post',
      url: `conversa/encerraConversaManutencao/${idConversa}`
    })
  },
  async fecharPendencia ({ commit }, idProcesso) {
    await axios({
      method: 'get',
      url: `conversa/processo/${idProcesso}/fechar/pendencia`
    })
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/conversa.js